import { CRITERION_VALUE } from "@/constants/criterion-values"

import { isValidCriterionResult, type CriterionResult } from "../../types"

interface CompositeResultSource {
  result?: Record<string, unknown> | null
  result_json?: Record<string, unknown> | null
}

const extractResultsFromField = (
  field: Record<string, unknown> | null | undefined,
): CriterionResult[] => {
  const parsed = field as
    | { individual_results?: CriterionResult[] }
    | null
    | undefined
  if (!Array.isArray(parsed?.individual_results)) {
    return []
  }
  return parsed.individual_results.map((item) => ({
    ...item,
    result: isValidCriterionResult(item.result)
      ? item.result
      : CRITERION_VALUE.UNKNOWN,
  }))
}

/** Returns the first non-empty Composite criterion payload. */
export function extractCompositeResults(
  source: CompositeResultSource | null | undefined,
): CriterionResult[] {
  const typedResults = extractResultsFromField(source?.result)
  return typedResults.length > 0
    ? typedResults
    : extractResultsFromField(source?.result_json)
}
